var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.346847 12.9784C-0.115616 13.4409 -0.115616 14.1907 0.346847 14.6532C0.80931 15.1156 1.55911 15.1156 2.02157 14.6532L7.5 9.17473L12.9784 14.6532C13.4409 15.1156 14.1907 15.1156 14.6532 14.6532C15.1156 14.1907 15.1156 13.4409 14.6532 12.9784L9.17473 7.5L14.6532 2.02157C15.1156 1.55911 15.1156 0.809311 14.6532 0.346847C14.1907 -0.115616 13.4409 -0.115616 12.9784 0.346848L7.5 5.82527L2.02157 0.346848C1.55911 -0.115615 0.80931 -0.115615 0.346847 0.346848C-0.115616 0.809311 -0.115616 1.55911 0.346847 2.02157L5.82527 7.5L0.346847 12.9784Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.be42a0f5bfbf5dc789782980756f056d.svg";
export { ForwardRef as ReactComponent };